import { IScore } from "../../../../../common/types";

export const getIncorrectNotes = (score: IScore, _incorrectNotes: { bar: number, note: number}[]) => {
    const incorrectNotes: number[][] = [[]];
    for (let v = 0; v <= 0; v++) {
        let totalNoteIndex = 0;
        const bars = score["bars" + (v || "")];
        for (let b = 0; b < bars.length; b++) {
            const bar = bars[b];
            if (bar === null) continue;
            for (let n = 0; n < bar.notes.length; n++) {
                if (_incorrectNotes.find(iN => iN.bar === b && iN.note === n)) {
                    incorrectNotes[v].push(totalNoteIndex);
                }
                totalNoteIndex++;
            }
        }
    }
    return incorrectNotes;
};
